import { observable } from "@legendapp/state";

/**
 * In-session preference for the left navigation sidebar.
 *
 * Kept separate from the SidebarProvider state so that routes which force the
 * sidebar to a specific state (e.g. settings, which always shows the sidebar)
 * don't clobber the user's preferred open/closed value when they navigate back.
 *
 * Not persisted across reloads — every page load starts with the sidebar open.
 */
export const sidebar$ = observable({
  leftOpen: true,
});
